import { useMemo } from 'react';
import { prop } from 'ramda';
import { useFormsSelector } from 'js/store/hooks';
import { IFormConfig } from 'js/components/common/Form/types';

export const useForm = ({ formName, customFormConfig }: { formName: string; customFormConfig: IFormConfig }) => {
    const forms = useFormsSelector(prop('forms'));

    return useMemo(
        () => customFormConfig || forms.find((_form) => _form.name === formName),
        [customFormConfig, forms, formName]);
};
